<template>
  <section
    v-if="snacks"
    class="snacks">
    <h1 class="snacks-section-title">Snacks</h1>
    <div class="columns-container">
      <div
        v-for="snack in snacks"
        :key="snack.id"
        class="columns snack">
        <div class="column is-7 snack-image">
          <img
            :src="snack.image.guid"
            :alt="snack['snack-title']"
            :title="snack['snack-title']">
        </div>
        <div class="column is-5 snack-info">
          <h3>{{ snack['snack-title'] }}</h3>
          <p>{{ snack.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Snacks',
  computed: {
    ...mapState([
      'snacks',
    ]),
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import "~@/sass/variables";

.snacks {
  margin-bottom: 2rem;

  @include tablet {
    padding: 0 4%;
  }

  .snacks-section-title {
    color: lighten($dark-cyan-gray, 30);
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
    padding-left: 4%;

    @include tablet {
      padding: 0;
    }

    @include from(1000px) {
      font-size: 1.5rem;
    }
  }

  .snack {
    margin-bottom: 2rem;
  }

  @include tablet {
    .snack:nth-of-type(odd) {
      .snack-info {
        order: -1;
      }
    }

    .snack {
      .snack-info {
        padding: 0.5rem;
      }
    }
  }

  @include desktop {
    .snack {
      margin-bottom: 0;
      &:nth-of-type(even) {
        margin-top: -3.75rem;
      }
    }
  }

  .snack-info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-left: calc(4% + 0.75rem);
    padding-right: calc(4% + 0.75rem);

    h3{
      color: #fff;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 1rem;
      text-align: left;
      width: 100%;

      @media screen and (min-width: 540px) {
        font-size: 1.25rem;
      }
    }

    p {
      color: #fff;
      display: block;
      width: 100%;
    }
  }
}
</style>
